export function getUtcDate(dateToFormat: Date): Date {
  const utcDate = new Date(
    Date.UTC(
      dateToFormat.getFullYear(),
      dateToFormat.getMonth(),
      dateToFormat.getDate()
    )
  );

  return utcDate;
}
